const ITEMS = [
    "Spese",
    "Visite mediche",
    "Accompagnamento",
    "Passeggiate",
    "Supporto quotidiano",
    "Per tutte le età",
];

const Track = ({ hidden }) => (
    <ul
        aria-hidden={hidden || undefined}
        className="flex w-max shrink-0 items-center"
    >
        {ITEMS.map((item) => (
            <li key={item} className="flex items-center">
                <span className="whitespace-nowrap px-8 font-serif text-2xl sm:text-3xl font-light italic text-ink">
                    {item}
                </span>
                <span
                    aria-hidden="true"
                    className="h-2 w-2 rounded-full bg-terracotta"
                />
            </li>
        ))}
    </ul>
);

export const Marquee = () => (
    <section
        data-testid="editorial-marquee"
        className="overflow-hidden border-y border-line bg-sand py-6"
    >
        <div className="flex w-max animate-marquee">
            <Track />
            <Track hidden />
        </div>
    </section>
);

export default Marquee;
